export function getStartOfDay() {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return now.getTime(); // retorna en ms
}

export function getStartOfMonth() {
    const now = new Date();
    now.setDate(1);
    now.setHours(0, 0, 0, 0);
    return now.getTime();
}

export function getLast7Dates() {
    const dates = [];
    for (let i = 6; i >= 0; i--) {
        const d = new Date();
        d.setDate(d.getDate() - i);
        const iso = d.toISOString().split("T")[0]; // YYYY-MM-DD
        dates.push(iso);
    }
    return dates;
}

export function getLast6Months() {
    const months = [];
    const today = new Date();
    const y = today.getFullYear();
    const m = today.getMonth() + 1; // 1-12
    for (let i = 5; i >= 0; i--) {
        let tmpMonth = m - i;
        let tmpYear = y;
        if (tmpMonth <= 0) {
            tmpMonth += 12;
            tmpYear -= 1;
        }
        const key = `${tmpYear}-${String(tmpMonth).padStart(2, "0")}`;
        months.push(key);
    }
    return months;
}
